import PageShell from "@/components/site/PageShell";

export default function LegalPage({ title, kicker, sections, updated }) {
  return (
    <PageShell>
      <section className="bg-background py-16 md:py-24" data-testid={`legal-${kicker}`}>
        <div className="mx-auto max-w-3xl px-5 md:px-10">
          <span className="mono-label text-primary">/ {kicker}</span>
          <h1 className="mt-6 font-display font-black uppercase tracking-tighter text-4xl md:text-6xl leading-[0.9]">
            {title}
          </h1>
          <p className="mono-label text-muted-foreground mt-6">Last updated: {updated}</p>

          <div className="mt-12 space-y-10 border-t border-white/10 pt-10">
            {sections.map((s, i) => (
              <div key={i}>
                <h2 className="font-display font-bold uppercase tracking-tight text-xl md:text-2xl mb-3 flex items-baseline gap-3">
                  <span className="font-mono-tech text-primary text-sm">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  {s.heading}
                </h2>
                <div className="text-foreground/70 leading-relaxed space-y-3 text-[0.95rem]">
                  {s.body.map((p, j) => (
                    <p key={j}>{p}</p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </PageShell>
  );
}
